import { render, staticRenderFns } from "./organization-add.view.vue?vue&type=template&id=645d3116&"
import script from "./organization-add.view.vue?vue&type=script&lang=ts&"
export * from "./organization-add.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports